// Helper function to clean and format URLs
const cleanUrl = (path) => {
  const baseUrl = process.env.REACT_APP_PROOH_SERVER?.replace(
    /[\"\']/g,
    ""
  ).replace(/\/$/, "");
  return `${baseUrl}${path}`;
};

export const screenV2 = cleanUrl("/api/v2/screens");
export const campaignV2 = cleanUrl("/api/v2/campaigns");
export const creativeV2 = cleanUrl("/api/v2/creatives");
export const userV1 = cleanUrl("/api/v1/users");
export const planningRouterURL = cleanUrl("/api/v2/planning");
export const monitoringURL = cleanUrl("/api/v2/monitoring");
export const dashboardURL = cleanUrl("/api/v2/dashboard");
export const couponURL = cleanUrl("/api/v2/coupon");
export const clientAgencyURL = cleanUrl("/api/v2/clientAgency");
export const analyticsURL = cleanUrl("/api/v1/analytics");
export const billInvoiceURL = cleanUrl("/api/v2/billInvoice");
export const analyticsV1 = cleanUrl("/api/v1/analytics");
export const awsV1 = cleanUrl("/api/v1/aws");
export const orgV2 = cleanUrl("/api/v2/org");

export const cmsURL = "https://cms.prooh.ai/home";
export const planningURL = "https://plan.prooh.ai/home";
export const dmpURL = "https://dmp.prooh.ai";
